import {
  Dispatch,
  ReactElement,
  RefObject,
  SetStateAction,
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
type Content = {
  component: JSX.Element | null;
  justify: "center" | undefined;
} | null;

const modalContext = createContext<{
  setContent: Dispatch<SetStateAction<Content>>;
  containerRef?: RefObject<HTMLDivElement>;
}>({
  setContent: () => {},
});
export const useModal = () => {
  const { setContent } = useContext(modalContext);
  return setContent;
};

export const useModalRef = () => {
  const { containerRef } = useContext(modalContext);
  return { containerRef };
};
export const ModalProvider = ({ children }: ReactElement["props"]) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [content, setContent] = useState<Content>(null);
  useEffect(() => {
    if (content?.component) {
      window.document.body.style.overflow = "hidden";
    } else {
      window.document.body.style.overflow = "auto";
    }
  }, [content?.component]);
  return (
    <modalContext.Provider value={{ setContent, containerRef }}>
      <div
        ref={containerRef}
        className={content?.component ? "" : "hidden"}
        style={{
          position: "fixed",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 100,
          height: "100vh",
          width: "100vw",
          maxWidth: "100%",
          overflow: "auto",
        }}
        onClick={() => setContent(null)}
      >
        <button
          style={{
            cursor: "pointer",
            position: "fixed",
            top: 8,
            left: 20,
            width: 64,
            height: 64,
            borderRadius: 24,
            fontSize: "2rem",
            zIndex: 101,
          }}
          onClick={() => setContent(null)}
        >
          ❎
        </button>
        <div
          style={{
            width: "100%",
            height: "100%",
            margin: "auto",
            justifyContent: content?.justify,
            display: "flex",
            position: "relative",
          }}
        >
          {content?.component}
        </div>
      </div>
      <>{children}</>
    </modalContext.Provider>
  );
};
